export enum LicenseActions {
    activateBookLicenses = '[license] activateBookLicenses',
    activateBookLicensesSuccess = '[license] activateBookLicensesSuccess',
    activateBookLicensesFailed = '[license] activateBookLicensesFailed',
    processLicensesSuccess = '[license] processLicensesSuccess',
    processLicensesFailed = '[license] processLicensesFailed',
}
